import { handleRedirect } from '@/utils/redirectHandler';

export default function isTheRightStep({ to, next, store }) {
  if (store.getters['register/registrationStep'] === to.name) {
    return next();
  }
  store.dispatch('appLogout');

  return next({
    name: 'REDIRECT',
    query: { redirect: handleRedirect(to.query.redirect) },
  });
}
